export default "__VITE_ASSET__Dt48Peiz__"